import { ActionTree } from 'vuex'
import { WidgetState } from "@/apps/StudentExchangePartnerWidget/models/store-viewmodel"
import { ILabels } from "@/apps/StudentExchangePartnerWidget/models/config-viewmodel"
import services from "@/apps/StudentExchangePartnerWidget/services"
import {AxiosResponse} from "axios"

export default <ActionTree<WidgetState, any>>{
    setLoading(context, payload: boolean): void {
        context.commit('loading', payload)
    },
    setLabels(context, payload: ILabels): void {
        context.commit('labels', payload)
    },
    setSignUp(context, payload: boolean): void {
        context.commit('signUp', payload)
    },
    setInsurance(context, payload: boolean): void {
        context.commit('insurance', payload)
    },
    setPrivacy(context, payload: boolean): void {
        context.commit('privacy', payload)
    },
    setProgramId(context, payload: number) {
        context.commit('programId', payload)
    },
    setRedirectUrl(context, payload: string): void {
        context.commit('redirectUrl', payload)
    },
    setLanguage(context, payload: string): void {
        context.commit('language', payload)
    },
    setErrorMessage(context, payload) {
        context.commit('errorMessage', payload)
    },
    loadStudyName(context, payload)
    {
        let getters = context.getters;
        services.studentStudy.getStudyName(getters.getLanguage, getters.getProgramId)
            .then((response: AxiosResponse) => {
                if (response.status === 204) {
                    context.commit('studyName', '')
                } else {
                    context.commit('studyName', response.data)
                }
            })
            .catch(() => {

            })
            .finally(() => {
                
            })
    },
    addStudentExchangePartner(context, payload) {
        context.commit('loading', true)
        context.commit('errorMessage', null)

        let getters = context.getters;

        services.studentExchange.postStudentExchangePartner(getters.getProgramId, getters.getInsurance, getters.getPrivacy)
            .then((response: AxiosResponse) => {
                window.open(getters.getRedirectUrl, '_self')
            })
            .catch(() => {
                context.commit('loading', false)
                context.commit('errorMessage', getters.getLabels.mobilityOnlineRequestErrorLabel)
            })
            .finally(() => {
                context.commit('loading', false)
            })
    }
}
